import { Component, theme } from '@atomica.co/components';
import { Message } from '@atomica.co/utils';
import { Typography } from '@material-ui/core';
import React from 'react';
import { RouteComponentProps } from 'react-router';
import styled from 'styled-components';
import mojaco from './../../assets/mojaco/mojaco_sorry.png';

interface P extends RouteComponentProps {
  message: Message;
}

const ErrorMessage: React.FC<P> = React.memo(props => {
  const { message } = props;

  return (
    <Component className='error-message'>
      <Container>
        <Image src={mojaco} />

        <StyledMessage>{message}</StyledMessage>
      </Container>
    </Component>
  );
});

export default ErrorMessage;

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
`;

const Image = styled.img`
  width: 100%;
  max-width: 400px;
  height: auto;
  margin: ${theme.mixins.spacing * 3}px;
`;

const StyledMessage = styled(Typography)`
  width: 100%;
  height: auto;
  color: ${theme.mixins.typography.fontColor.gray};
  font-size: ${theme.mixins.typography.fontSize.twenty}px;
  font-weight: ${theme.mixins.typography.fontWeight.fourHundreds};
  font-family: Mamelon, ${theme.mixins.typography.fontFamily};
  text-align: center;
  white-space: pre-line;
`;
